import React from 'react';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import CertificationLink from 'areas/shared/components/formatter/CertificationLink';
import DateColor from 'areas/admin/shared/DateColor';
import AssigneeStatus from 'areas/admin/shared/AssigneeStatus';
import DaysOpen from 'areas/admin/shared/DaysOpen';
import FlagFormatter from 'areas/admin/shared/FlagFormatter';

const columns = [
	{ key: 'flags', name: 'Flag', width: 40, formatter: FlagFormatter, sortable: false },
	{ key: 'appId', name: 'App ID', width: 55, formatter: CertificationLink, getRowMetaData: (row) => row, sortable: false },
	{ key: 'type', name: 'Type', width: 110, sortable: false },
	{ key: 'track', name: 'Track', width: 70, sortable: false },
	{ key: 'open', name: 'Open', formatter: DaysOpen, width: 55, sortable: false },
	{ key: 'vobName', name: 'Company', width: 115, sortable: false },
	{ key: 'state', name: 'State', width: 50, sortable: false },
	{ key: 'veteran', name: 'Veteran Name', width: 125, sortable: false },
	{ key: 'veteranEmail', name: 'Veteran Email', width: 125, sortable: false },
	{ key: 'dD214Status', name: 'DD214', width: 85, formatter: DateColor, getRowMetaData: (row) => row, sortable: false },
	{ key: 'app', name: 'App', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'APP'}), sortable: false },
	{ key: 'cert', name: 'Cert', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'CER'}), sortable: false },
	{ key: 'comm', name: 'Comm', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'COM'}), sortable: false },
	{ key: 'site', name: 'Site', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'STR'}), sortable: false },
    { key: 'final', name: 'Final', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'FIN'}), sortable: false }
	// { key: 'selectedQueueTypeCode', visible: false, sortable: false }
];

class FlaggedCertifications extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			list: []
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	handleSearch = (filters, callback) => {
		this.setState({
			list: []
		}, function () {
			this.search(null, callback);
		});
	}

	onExportData = () => {
		const rq = Object.assign({});

		new API().post(APIModules.Admin.url('/dashboard/getFlaggedCertificationsExport'), rq,
			{
				success: (sr) => {
					new API().download(sr.data);
				}
			});
	}

	search = (opts, callback) => {
		const rq = Object.assign({});

		var state = {
			list: []
		};

		new API().post(APIModules.Admin.url('/dashboard/getFlaggedCertifications'), rq,
			{
				success: (r) => {
					state = {
						list: r.data.items
					};
					
					// Store search results
					this.setState(state);

					// Callback
					if (callback)
						callback();
				}
			});

		return state;
	}

	render() {
		return (
			<React.Fragment>
				<Grid
					columns={columns}
					items={this.state.list}
					height={200}
					className="table-condensed"
					rowKey="id"
					name="default" />
				<hr />
				<div className="btn-toolbar">
					{this.state.list &&
						<Button
							id="btnExportCsv"
							onClick={this.onExportData}
							className="btn btn-default pull-right" >
							<FontAwesomeIcon icon={faFileExport} /> Export CSV
						</Button>
					}
				</div>
			</React.Fragment>
		)
	}
}

export default FlaggedCertifications;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/flaggedCertifications/FlaggedCertifications.js